"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyCheckBoxMenu = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyCheckBox_1 = require("../SskyCheckBox/SskyCheckBox");

const SskyTooltip_1 = require("../SskyTooltip/SskyTooltip");

const StyledMenuItem = (0, material_1.styled)(material_1.MenuItem)({
  height: 48
});

const SskyCheckBoxMenu = props => {
  const renderItem = item => {
    return react_1.default.createElement(StyledMenuItem, {
      key: item.content,
      disabled: item.disabled,
      onClick: item.onClick,
      "data-testid": item.dataTestId || `testId-${item.content}`
    }, react_1.default.createElement(SskyCheckBox_1.SskyCheckBox, {
      checked: item.checked,
      indeterminate: item.indeterminate
    }), react_1.default.createElement(material_1.ListItemText, {
      primary: item.content,
      className: "checkbox-menu-list-item-text"
    }));
  };

  const renderItems = () => {
    return props.items.map(item => {
      if (item.tooltip) {
        return react_1.default.createElement(SskyTooltip_1.SskyTooltip, {
          title: item.tooltip,
          enterDelay: 300,
          placement: "right",
          left: props.tooltipLeft,
          key: item.content
        }, react_1.default.createElement("div", null, renderItem(item)));
      } else {
        return renderItem(item);
      }
    });
  };

  return react_1.default.createElement(material_1.Menu, {
    id: props.id,
    anchorEl: props.anchor,
    open: props.open,
    onClose: props.onClose,
    "data-testid": props.dataTestId || `testId-${props.id}`,
    disableRestoreFocus: true,
    PaperProps: {
      style: {
        maxHeight: props.maxHeight,
        minWidth: 100
      }
    }
  }, renderItems());
};

exports.SskyCheckBoxMenu = SskyCheckBoxMenu;
exports.default = react_1.default.memo(SskyCheckBoxMenu);